export function gridColumnsClass(columnNumber) {
  const columnClasses = {
    1: 'one-column-grid-template',
    2: 'two-column-grid-template',
    3: 'three-column-grid-template',
    4: 'four-column-grid-template'
  }
  return columnClasses[columnNumber]
}

export function gridColumnBgColor(color) {
  const colorName = color.toLowerCase().replace(/\s/g, '')
  const colorClasses = {
    dark: 'bg-navy',
    gray: 'bg-gray',
    lightgray: 'bg-light-gray',
    white: 'bg-white',
    primaryblue: 'bg-blue'
  }
  return colorClasses[colorName]
}

export function formGridColumnsClass(columnNumber) {
  const columnClasses = {
    1: 'col-1',
    2: 'col-2',
    3: 'col-3',
    4: 'col-4',
    5: 'col-5',
    6: 'col-6',
    7: 'col-7',
    8: 'col-8',
    9: 'col-9',
    10: 'col-10',
    11: 'col-11',
    12: 'col-12'
  }
  return columnClasses[columnNumber]
}
